import { render, staticRenderFns } from "./IconInformationCircle.vue?vue&type=template&id=7ed9d8fc&"
import script from "./IconInformationCircle.vue?vue&type=script&lang=js&"
export * from "./IconInformationCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports